import * as Sentry from '@sentry/browser'

export default function initSentry() {
  const railsEnv = document.querySelector('meta[name="rails-env"]')?.getAttribute('content');

  if (railsEnv === 'production' || railsEnv === 'staging') {
    const release = document.querySelector('meta[name="sentry-release"]')?.getAttribute('content') || undefined;

    Sentry.init({
      environment: railsEnv,
      release,
      dsn: 'https://7c2a37139f2d4be9bc384784b0f824d1@o579424.ingest.us.sentry.io/5494950',
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
        Sentry.thirdPartyErrorFilterIntegration({
          filterKeys: ['nada-app'],
          behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
        }),
      ],
      tracesSampleRate: 0.25,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      ignoreErrors: [
        "Non-Error promise rejection captured with value: Object Not Found Matching Id", // https://github.com/getsentry/sentry-javascript/issues/3440
        "Maximum call stack size exceeded", // Sentry SDK recursion bug with browser extensions (NADA-1J1)
        // Network-level fetch failures (offline, navigated away mid-request, blocked by extension/crawler).
        // Turbo rethrows these from FetchRequest.perform as unhandled rejections; nothing actionable (NADA-1TP, NADA-1V9).
        "Load failed", // Safari
        "Failed to fetch", // Chrome
        "NetworkError when attempting to fetch resource", // Firefox
        // Aborted requests: Turbo cancels superseded frame/visit fetches, or the user navigated away (NADA-1K5, NADA-2EV).
        "The user aborted a request",
        "Fetch is aborted",
        // View transitions interrupted by a faster second navigation (NADA-1XD, NADA-1YE, NADA-1KT).
        "Transition was aborted because of invalid state",
        "Old view transition aborted by new view transition",
        // Browser extension frames with no stack, so thirdPartyErrorFilterIntegration can't see them (NADA-1JK).
        "Invalid call to runtime.sendMessage()"
      ]
    });

    // Set user context if logged in (ID only, no PII)
    const userId = document.querySelector('meta[name="sentry-user-id"]')?.getAttribute('content');
    if (userId) {
      Sentry.setUser({ id: userId });
    }
  }
}
